// extracted by mini-css-extract-plugin
export default {"menu-links__list-item":"NavbarLinks_menu-links__list-item__REb0n","menu-links__link":"NavbarLinks_menu-links__link__o9wHR"};